/* Built In Imports */
/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button, Center, Flex, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Services */

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const GenLocation = ({ sectionContent }) => {
  return (
    <Box
      mx="auto"
      w="100%"
      maxW={{ base: '100%', md: '100%', lg: '100%', xl: 1102, '2xl': '1102px' }}
      py={{ base: '30px', md: '40px', xl: '60px' }}
    >
      <Box w="100%">
          <Text
            fontFamily="var(--FedraSansCondensedMedium), sans-serif"
            color="#fff"
            fontSize={{ md: '46px', base: '40px' }}
            lineHeight="160%"
            textTransform="uppercase"
            as="h2"
            pb="20px"
            pl={{base:"20px", sm:"20px", md:"20px", xl:"0px"}}
          >
            {sectionContent[0]?.titleText}
          </Text>
        <Flex
          backgroundColor="#17175F"
          flexDirection={{ base: 'column', md: 'row' }}
          //flexGrow={1}
          alignItems="stretch"
          margin={{base:"10px", sm:"10px", md:"20px", lg:"auto"}}
        >
          {sectionContent &&
            sectionContent[1]?.cards?.map((item, i) => (
              <Box
                key={`jUwj3${i}`}
                flexGrow={1}
                //flexBasis={1}
                //width={"90%"}
                //mx="auto"
                w={{base:"auto", sm:"auto", md:i === 1 ? "569px" : i === 2 ? "294px" : "100%"}}
                my={{ md: '36px', lg: '34px' }}
                px={{ base: '20px', sm:"20px", md: '18px', lg: '35px' }}
                borderLeft={{
                  md: i === 0 ? 'none' : '1px solid rgba(255, 255, 255, 0.30)',
                }}
                borderBottom={{
                  base:
                    i === 1 ? 'none' : '1px solid rgba(255, 255, 255, 0.30)',
                  md: 'none',
                }}
              >
                <Flex>
                <Box
                  fontFamily="var(--FedraSansStd-medium)"
                  color="#FFFFFF"
                  fontSize={'20px' }
                  pt={{ base: '20px', md: '0px' }}
                >
                  {item?.title}
                </Box>
                {item?.sessions && (
                <Box
                fontFamily="var(--FedraSansStd-medium)"
                color="#000000"
                fontSize={'10.39px' }
                background={"#FF9900"}
                lineHeight={"21px"}
                width={"123.39px"}
                height={"20.96px"}
                borderRadius={"-5px"}
                textAlign={"center"}
                margin={{base:"25px", sm:"25px", md:"7px", xl:"7px"}}
                className='ribbon'
                >
                {item?.sessions}
                </Box>  
                )};
                </Flex>  
                <Box
                  color="#D4D4FA"
                  fontSize={{ md: '16px' }}
                  p={{ base: '15px 0px 0 0', sm:"0 0 0 20px", md: '15px 0px 0 0' }}
                >
                  <StructuredTextParser
                    str={render(item?.description)}
                    mt="0"
                    color="#D4D4FA"
                    fontSize="16px"
                    maxW="none"
                    p="0"
                  />
                  <LazyLoadImageComponent
                    src={item?.thumbnail?.url}
                    pt="10px"
                  />
                </Box>
              </Box>
            ))}
        </Flex>
      </Box>
      <style global jsx>
        {`
          .ribbon {
            --r : 10px;
            padding-inline: calc(var(--r) + .3em);
            line-height: 1.8;
            clip-path: polygon(0 0, 100% 0, calc(100% - var(--r)) 50%, 100% 100%, 0 100%, var(--r) 50%);
            background: #FF9900;
            width: fit-content;
          }
        `}
      </style>
    </Box>
  );
};

export default GenLocation;
